import React from "react";

const COLORS = [
  "bg-[#7C2D12]", "bg-[#1E3A8A]", "bg-[#9F1239]", "bg-[#15803D]",
  "bg-[#B45309]", "bg-[#6D28D9]", "bg-[#155E75]", "bg-[#A16207]",
];

function colorFor(seed) {
  let hash = 0;
  for (let i = 0; i < (seed || "").length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function Avatar({ user, size = "sm", title, testid }) {
  const sizeClass = {
    xs: "w-5 h-5 text-[9px]",
    sm: "w-7 h-7 text-[10px]",
    md: "w-9 h-9 text-xs",
    lg: "w-12 h-12 text-sm",
  }[size];
  const initials = user?.avatar_initials || (user?.name ? user.name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase() : "?");
  const seed = user?.id || user?.email || initials;
  return (
    <div
      title={title || user?.name || initials}
      data-testid={testid}
      className={`${sizeClass} ${colorFor(seed)} rounded-full flex items-center justify-center text-white font-semibold ring-2 ring-[#0B0B0E] select-none`}
    >
      {initials}
    </div>
  );
}

export function AvatarStack({ users = [], max = 4, size = "sm" }) {
  const visible = users.slice(0, max);
  const more = Math.max(0, users.length - max);
  return (
    <div className="flex -space-x-2 items-center">
      {visible.map((u, i) => (
        <Avatar key={u?.id || i} user={u} size={size} />
      ))}
      {more > 0 && (
        <div className={`${size === "sm" ? "w-7 h-7 text-[10px]" : "w-9 h-9 text-xs"} bg-[#27272A] text-zinc-300 rounded-full flex items-center justify-center font-semibold ring-2 ring-[#0B0B0E]`}>
          +{more}
        </div>
      )}
    </div>
  );
}
